import {ROUTES_NAMES} from "../router";
import {
    axiosUsers,
    axiosUsersUrl
} from "../helpers/axios_requests";

export default {
  computed: {
    route_names() {
      return ROUTES_NAMES
    },
    api_routes() {
      return {
        users: {
          url: axiosUsersUrl,
          axios: axiosUsers
        },
      }
    }
  }

}
